import { Alert } from '@mui/material';
import React from 'react';
import ReactDOM from 'react-dom';

import { AsyncContent } from '~/components/AsyncContent';
import { PortalErrorBoundary } from '~/components/PortalErrorBoundary';
import { useAuthentication } from '~/data/user/useAuthentication';
import {
  allPortalDataDispatchReduxFetches,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';
import { useAnalyticsModuleViews } from '~/library/AnalyticsModuleViews/useAnalyticsModuleViews';
import {
  LibraryComponentProviders,
  LibraryComponentProviders_OnLegacyNavigation,
} from '~/library/components/LibraryComponentProviders';
import { Providers } from '~/Providers';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

export type AnalyticsModuleViewsProps =
  LibraryComponentProviders_OnLegacyNavigation & {
    viewPath: string;
  };

const AnalyticsModuelViewsContent = (props: AnalyticsModuleViewsProps) => {
  const { moduleView } = useAnalyticsModuleViews(props);

  if (moduleView?.isAvailable === false) {
    <Alert severity={'error'}>View not available</Alert>;
  }

  return !!moduleView?.component ? (
    <PortalErrorBoundary>{moduleView?.component}</PortalErrorBoundary>
  ) : (
    <Alert severity={'error'}>View not found</Alert>
  );
};

export const AnalyticsModuleViews = (props: AnalyticsModuleViewsProps) => {
  const { onLegacyNavigate } = props;

  const { isAuthenticated, failToLoad } = useAuthentication();

  const {
    requiredStatus: { isInitializing, percentage },
  } = useInitializeCommonReduxData({
    required: allPortalDataDispatchReduxFetches,
  });

  if (isInitializing || !isAuthenticated) {
    return <LoadingView>{percentage}</LoadingView>;
  }

  return (
    <LibraryComponentProviders onLegacyNavigate={onLegacyNavigate}>
      <AsyncContent
        isLoading={!isAuthenticated}
        failedToLoad={failToLoad}
        fullHeight={true}
      >
        <AnalyticsModuelViewsContent {...props} />
      </AsyncContent>
    </LibraryComponentProviders>
  );
};

export const renderAnalyticsModuleViews = (
  containerId: string,
  props: AnalyticsModuleViewsProps,
) => {
  ReactDOM.render(
    <Providers>
      <AnalyticsModuleViews {...props} />
    </Providers>,
    document.getElementById(containerId),
  );
};
